import type { ModuleRoute } from "@/types/core";
import { cn, layout, spacing, typography } from "@/utilities";

// Fallback component for coming soon routes
export const ComingSoonFallback = ({ route }: { route: ModuleRoute }) => {
  return (
    <div className={cn(layout.flexCenter, spacing.py16)}>
      <div className={cn(typography.textCenter)}>
        <h2 className={cn(typography.text2xlSemibold, spacing.mb4)}>
          {route.label}
        </h2>
        <p className={cn(typography.textMuted)}>
          This feature is coming soon—check back shortly for new tools and
          enhancements!
        </p>
      </div>
    </div>
  );
};

export default ComingSoonFallback;
